export const EVENT_DIMENSION_NAME = 'Events Category';

export const BRANDS_CRUMB_LABEL = 'Brands';
export const BRANDS_PAGE_URL = '/c/brands';
